import type { RecordSchema } from '@/types'

function value(src: unknown, next: unknown): unknown {
	let k
	if (src && next && typeof src === 'object' && typeof next === 'object') {
		if (Array.isArray(next)) {
			const srcArray = src as unknown[]
			for (k = 0; k < next.length; k++) {
				srcArray[k] = value(srcArray[k], next[k])
			}
		} else {
			const srcObj = src as Record<string, unknown>
			const nextObj = next as Record<string, unknown>
			for (k in nextObj) {
				srcObj[k] = value(srcObj[k], nextObj[k])
			}
		}
		return src
	}
	return next
}

export function merge<T>(target: T, ...args: unknown[]): T {
	const len: number = args.length
	for (let i = 0; i < len; i++) {
		target = value(target, args[i]) as T
	}
	return target
}

export function createQueryParam(obj: RecordSchema) {
	if ((obj && !Object.values(obj || {}).length) || !obj) {
		return ''
	}
	return Object.keys(obj || {})
		.map(key =>
			obj[key] !== undefined && obj[key] !== ''
				? encodeURIComponent(key) + '=' + encodeURIComponent(String(obj[key]))
				: ''
		)
		.filter(item => item)
		.join('&')
}
